// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostHeader_wrapper__TDLg9","featuredImage":"PostHeader_featuredImage__YmHa8","container":"PostHeader_container__EgAwk","heading":"PostHeader_heading__xREcv"};